// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".experience-wrapper--section-extras .el-form-item{margin-bottom:0}.experience-wrapper--section-extras .el-card__body{padding:0}.experience-wrapper--section-extras .extra-price{margin-left:auto;font-size:.8em;color:#4c4f56;font-weight:400}.experience-wrapper--section-extras .el-collapse-item__arrow{margin:0 10px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
